import { createFileRoute } from '@tanstack/react-router'
import { DetectionConfigurationFormPage } from 'pages/anomalyDetection/DetectionConfigurationFormPage'

export const Route = createFileRoute(
  '/anomaly-detection/$siteID/$detectionConfigurationId'
)({
  component: DetectionConfigurationFormPage,
  staticData: {
    title: 'Detection Configuration',
    layout: {
      enableScrolling: true,
      enforceMaxWidth: true,
    },
  },
})
